import makeStyles from '@material-ui/core/styles/makeStyles';

const drawerWidth = 230;

export default makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: ({ maintenanceStartTime }) =>
      theme.zIndex.drawer + (maintenanceStartTime < 0 ? 201 : 1),
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    '& div': {
      backgroundColor:
        theme.palette.type === 'light'
          ? theme.palette.background.defaultLightGrey
          : theme.palette.background.paper,
      borderRight: 'none',
    },
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: '48px',
  },
  toolbarSpacing: {
    // necessary for content to be below app bar
    marginTop: ({ maintenanceStartTime }) =>
      maintenanceStartTime ? '94px' : '64px',
  },
  drawerIcon: {
    backgroundSize: 'cover',
    width: '23px',
    height: '23px',
    backgroundRepeat: 'no-repeat',
    '&:active': {
      backgroundPosition: '-25px',
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  listItem: {
    height: '42px',
    width: '100%',
    padding: '8px 12px',
    borderLeft: '4px solid transparent',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  listItemIcon: {
    minWidth: '30px',
    marginLeft: props => (props.isOpen ? '0' : '-4px'),
  },
  fadeOutElement: {
    opacity: props => (props.isOpen ? 1 : 0),
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  activeListItem: {
    backgroundColor: theme.palette.background.sidebarActiveItem,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    '& div': {
      backgroundColor: theme.palette.background.sidebarActiveItem,
    },
    '& span': {
      color:
        theme.palette.type === 'light'
          ? theme.palette.primary.main
          : theme.palette.text.primary,
    },
    '& .sidebar-list-icon': {
      display: 'none',
    },
    '& .sidebar-list-active-icon': {
      display: 'block',
    },
  },
  poweredBy: {
    width: '100%',
    textAlign: 'center',
    fontFamily: theme.font.medium,
    color: theme.palette.grey[500],
    position: 'absolute',
    bottom: '32px',
    '& img': {
      width: '24px',
      marginLeft: props => (props.isOpen ? '49px' : '10px'),
      marginRight: '8px',
      float: 'left',
    },
    '& p': {
      width: '100%',
      position: 'relative',
      fontSize: theme.typography.fontSize,
      letterSpacing: '0.5px',
      marginBottom: '11px',
    },
    '& div': {
      float: 'right',
      fontSize: '12px',
      letterSpacing: '0.17px',
      width: '59%',
      textAlign: 'left',
    },
  },
  contentContainer: {
    position: 'relative',
    width: props =>
      props.isOpen ? `calc(100% - ${drawerWidth}px)` : 'calc(100% - 48px)',
  },
}));
